"use strict";

exports.__esModule = true;
exports.DeviceTag = DeviceTag;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../Theme");
var _excluded = ["value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var StyledTag = (0, _styledComponents["default"])(_core.Tag).withConfig({
  displayName: "DeviceTag__StyledTag",
  componentId: "sc-570fmq-0"
})(["color:", " !important;background:", " !important;"], function (props) {
  return props.disabled ? (0, _Theme.val)("DisabledText") : (0, _Theme.val)("TagTextColor");
}, (0, _Theme.val)("TagBackgroundColor"));

/**
 * Displays an individual device tag.
 */
function DeviceTag(_ref) {
  var value = _ref.value,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledTag, extra, value);
}